import {mapActions, mapState} from "ui.vue3.vuex";
import {ButtonLoad} from "./button-load";

export const ItemsList = {
    data(): object {
        return {
            isSearch: false
        }
    },
    components: {
        ButtonLoad,
    },
    computed: {
        ...mapState('itemsStore', ['items']),
    },
    methods: {
        ...mapActions('itemsStore', ['getDetailInfo']),
        getClassItem(id) {
            let classColor = '';
            switch (id) {
                case 'Кванториумы':
                    // Кванториумы
                    classColor = 'pink';
                    break;
                case 'IT-кубы':
                    // IT-кубы
                    classColor = 'green';
                    break;
                case 'Точки роста и школьные лаборатории':
                    // Точки роста и школьные лаборатории
                    classColor = 'turquoise';
                    break;
                case 'Психолого-педагогические классы':
                    // Психолого-педагогические классы
                    classColor = 'purple';
                    break;
                case 'Воспитательные практики':
                    // Воспитательные практики
                    classColor = 'mark';
                    break;
                case 'Диалог с родителями':
                    // Диалог с родителями
                    classColor = 'green-lt';
                    break;
                case 'Образовательный контент по предметам':
                    // Образовательный контент по предметам
                    classColor = 'mint';
                    break;
                case 'Дополнительное образование детей':
                    // Дополнительное образование детей
                    classColor = 'green';
                    break;
                case 'Справочник научно-методических разработок':
                    // Справочник научно-методических разработок
                    classColor = 'turquoise';
                    break;
            }

            return classColor;
        },
        getStyle(url) {
            return `--img-url: url(${url})`;
        },
        getInfo(id) {
            console.log(id)
            this.getDetailInfo(id)
        },
        getSubjects(subject) {
            let tmp =[];
            subject.forEach(function (item) {
                tmp.push(item.label);
            })
            return tmp.join(', ');
        }
    },
    template: `
    <div class="methodological-items" id="section-methodological-items">
        <div class="container-fluid">
          <div class="methodological-items__info" v-if="isSearch">{{ $Bitrix.Loc.getMessage('TITLE_ITEMS_LIST_FIND') }} 37 {{ $Bitrix.Loc.getMessage('TITLE_ITEMS_LIST_FIND_ELEMENT_NAME') }}</div>
          <div class="methodological-items__elements">          
            <a href="#popup-methodological-item" v-for="item in items"
               class="methodological-item methodological-items__element js-popup-btn-target" @click="getInfo(item.id)">
              <div class="methodological-item__content">
                <div class="methodological-item__sections">{{ getSubjects(item.education_subjects) }}</div>
                <div class="methodological-item__tags">
                  <div class="methodological-item__tag" :data-rubric-id="rubric.id" :class="getClassItem(rubric.label)" v-for="rubric in item.rubrics" :key="rubric.id">{{ rubric.label }}</div>
                </div>
                <div class="methodological-item__title">{{ item.title }}</div>
                <div class="methodological-item__excerpt"><span>{{ item.type.label }}</span> </div>
<!--                <div class="methodological-item__excerpt"><span v-for="direction in item.directions">{{ direction.label }}</span> </div>-->
                <div class="methodological-item__edu" :style="getStyle(item.owner_team.logo_url)" :data-url="item.owner_team.logo_url">{{ item.owner_team.name }}</div>
              </div>
              <div class="methodological-item__more">{{ $Bitrix.Loc.getMessage('TITLE_ITEMS_LIST_BTN_READ_MORE_TEXT') }}</div>
            </a>
          </div>
          <ButtonLoad></ButtonLoad>
        </div>
      </div>
    `
}